import React from 'react';
import { Image } from 'react-bootstrap';

export default function Logo(props) {
  return (
    <Image src="/logo192.png" {...props} />
  )
}
